// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__10udv","icon":"styles_icon__Izi8t","value":"styles_value__ocDGV","secondary":"styles_secondary__1p0dr","textUnderIcon":"styles_textUnderIcon__291pk"};